import { Component, createRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';

import withComponentName from '../../../../decorators/withComponentName';
import NewTag from '../../../Shared/NewTag';
import StorageSvc from '../../../../services/StorageSvc';

import Styles from './styles.module.scss';

import * as preferencesActions from '../../../../actions/preferencesActions';

const DIRECTIONS = {
  LEFT: 0x01,
  RIGHT: 0x02,
};

const cx = classNames.bind(Styles);

export class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTabFixed: false,
      leftArrowHidden: true,
      rightArrowHidden: true,
      navListStyles: {
        marginLeft: '0px',
      },
    };
    autoBind(this);
    this.topicMain = createRef();
    this.topicTab = createRef();
    this.navList = createRef();

    // distance between navbar items
    this.distanceBetween = 20;
    this.mounted = false;

    this.scrolling = false;
  }

  componentDidMount() {
    this.mounted = true;
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentDidUpdate(prevProps) {
    const {
      tabs, show, activeTab, width,
    } = this.props;
    if (tabs.length !== prevProps.tabs.length || show !== prevProps.show) {
      this.setState({
        navListStyles: {
          marginLeft: '0px',
        },
      }, () => {
        this.onResize();
      });
    }

    if (this.navList.current && activeTab) {
      const activeTabIndex = tabs.findIndex((tab) => (
        tab.id === activeTab
      ));
      if (activeTabIndex > -1) {
        const activeTabElement = this.navList.current.children[activeTabIndex];
        let boundingClientRect = activeTabElement.getBoundingClientRect().x;
        if (width >= 2800 && activeTabElement.getBoundingClientRect().x > 1366) {
          boundingClientRect = this.topicMain.current.clientWidth
            - activeTabElement.getBoundingClientRect().x;
        }
        if ((boundingClientRect + activeTabElement.clientWidth !== 0)
          && (boundingClientRect + activeTabElement.clientWidth
            > this.topicMain.current.clientWidth - (this.distanceBetween + 2)
            && !this.scrolling)
        ) {
          this.scroll(DIRECTIONS.RIGHT);
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.onResize);
    this.mounted = false;
  }

  handleScroll() {
    const { statePromo } = this.props;
    const { height } = statePromo;
    const tabTop = this.topicMain.current.getBoundingClientRect().top;
    if (!this.topicMain.current.className.includes('subTab') && !this.topicMain.current.className.includes('publicationTabs')) {
      this.setState({
        isTabFixed: (tabTop - (!StorageSvc.getItem('mobilePopupSeen') ? 0 : height)) <= 0,
      });
    }
  }

  onResize() {
    this.distanceBetween = window.innerWidth >= 768 ? 48 : 29;

    if (this.mounted) {
      this.setState(({ navListStyles }) => ({
        leftArrowHidden: parseInt(navListStyles.marginLeft, 10) === 0,
        rightArrowHidden: (
          this.topicTab.current.offsetWidth >= (
            this.navList.current.offsetWidth + parseInt(navListStyles.marginLeft, 10)
          )
        ),
      }));
    }
  }

  onTabClick(id) {
    const { onTabClick, actions } = this.props;
    const tabTop = this.topicMain.current.getBoundingClientRect().top;
    if (tabTop <= 0) {
      const offsetTop = window.pageYOffset + tabTop;
      onTabClick(id, offsetTop);
    } else {
      onTabClick(id);
    }
    actions.toggleStoryFilters(false);
  }

  scroll(direction) {
    const { navListStyles } = this.state;
    switch (direction) {
      case DIRECTIONS.LEFT: {
        let width = 0;

        for (let i = 0; i < this.navList.current.children.length; i += 1) {
          width += this.navList.current.children[i].offsetWidth + this.distanceBetween;

          if (
            -parseInt(navListStyles.marginLeft, 10) - this.topicTab.current.offsetWidth <= width
          ) {
            width -= this.navList.current.children[i].offsetWidth + this.distanceBetween;
            break;
          }
        }

        this.trackScrollingState();
        this.setState({
          navListStyles: {
            marginLeft: `${-Math.max(width, 46) + 46}px`,
          },
        }, () => {
          this.onResize();
        });
        break;
      }
      case DIRECTIONS.RIGHT: {
        let width = 0;

        for (let i = 0; i < this.navList.current.children.length; i += 1) {
          width += this.navList.current.children[i].offsetWidth + this.distanceBetween;

          if (
            -parseInt(navListStyles.marginLeft, 10) + this.topicTab.current.offsetWidth <= width
          ) {
            width -= this.navList.current.children[i].offsetWidth + this.distanceBetween;
            break;
          }
        }

        this.trackScrollingState();
        this.setState(({
          navListStyles: {
            marginLeft: `${-width + 46}px`,
          },
        }), () => {
          this.onResize();
        });
        break;
      }
      default:
    }
  }

  trackScrollingState() {
    this.scrolling = true;
    setTimeout(() => {
      this.scrolling = false;
    }, 300);
  }

  render() {
    const {
      tabs, activeTab, statePromo, classname, width,
    } = this.props;
    const {
      isTabFixed, leftArrowHidden, rightArrowHidden, navListStyles,
    } = this.state;
    const tabsHolderClass = cx('tabs_holder', { fixed: isTabFixed }, classname);
    const { height } = statePromo;
    const countTop = `${height}px`;

    return (
      <div className={cx('tabs_main_holder', classname)} ref={this.topicMain} id="watchlists_tab_bar_holder">
        <div
          className={tabsHolderClass}
          ref={this.topicTab}
          style={{ top: isTabFixed && (width > 767 || StorageSvc.getItem('mobilePopupSeen')) ? countTop : 0 }}
        >
          <div
            hidden={leftArrowHidden}
            className={cx('arrow_left', classname)}
            onClick={() => this.scroll(DIRECTIONS.LEFT)}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </div>
          <div
            ref={this.navList}
            className={cx('tabs', classname)}
            style={navListStyles}
          >
            {
              tabs.map(({
                id, content, isBeta, isNew,
              }) => (
                <Tab
                  key={id}
                  id={id}
                  content={content}
                  activeTab={activeTab}
                  onTabClick={this.onTabClick}
                  isBeta={isBeta}
                  isNew={isNew}
                  classname={classname}
                />
              ))
            }
          </div>
          <div
            hidden={rightArrowHidden}
            className={cx('arrow_right', classname)}
            onClick={() => this.scroll(DIRECTIONS.RIGHT)}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </div>
      </div>
    );
  }
}

const Tab = ({
  id, content, activeTab, onTabClick, isNew, classname,
}) => {
  const tabClass = cx('tab', { active: activeTab === id }, classname);
  const handleClick = () => {
    onTabClick(id);
  };

  return (
    <div className={tabClass}>
      <div className={cx('tab_title', classname)} onClick={handleClick}>
        {content}
        {classname && <div className={cx('tab_border')} />}
      </div>
      {isNew && (<NewTag className={cx('tab_new', classname)} />)}
    </div>
  );
};

const mapStateToProps = (state) => ({
  statePromo: state.promobar,
  width: state.common.width,
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...preferencesActions,
    }, dispatch),
  };
}

export default withComponentName(
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Tabs),
);
